import { render } from "./DetailSuabow.vue?vue&type=template&id=12e65439&scoped=true"
import script from "./DetailSuabow.vue?vue&type=script&lang=js"
export * from "./DetailSuabow.vue?vue&type=script&lang=js"

import "./DetailSuabow.vue?vue&type=style&index=0&id=12e65439&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-12e65439"

export default script